export default "__VITE_ASSET__DiDivgzW__"